"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlocksEnteredScreenCard = exports.HELP_TEXT = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BlockTypeDisplayMappings_1 = require("Analytics/Page/BlockTypeDisplayMappings");
var commonStyles = __importStar(require("../../CommonStyles.css"));
var icons_1 = require("@qwilr/kaleidoscope/icons");
var SessionViewTimeline_css_1 = require("./SessionViewTimeline.css");
exports.HELP_TEXT = "You may see a given block listed as entering the screen multiple times. This is common, occurring when a user scrolls up and down the body of the page first before interacting with it's content";
var BlocksEnteredScreenCard = function (_a) {
    var interactionEventData = _a.interactionEventData;
    var isSingleEvent = interactionEventData.blocks.length === 1;
    var headingText = isSingleEvent ? "Block Entered Screen" : "Blocks Entered Screen";
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "s" },
        react_1.default.createElement(kaleidoscope_1.Heading, { strong: true, level: "5", align: "left" }, headingText),
        react_1.default.createElement(kaleidoscope_1.Tooltip, { content: exports.HELP_TEXT, targetClassName: SessionViewTimeline_css_1.helpButton, size: kaleidoscope_1.TooltipSize.Large },
            react_1.default.createElement(icons_1.Help, null)),
        react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs" }, interactionEventData.blocks.map(function (b, index) {
            var Icon = (0, BlockTypeDisplayMappings_1.getBlockIcon)(b.blockType);
            return (react_1.default.createElement(kaleidoscope_1.Stack, { key: index, direction: "horizontal", align: "center", gap: "s" },
                Icon !== null && react_1.default.createElement(Icon, { className: commonStyles.minIconWidth, color: "default" }),
                react_1.default.createElement(kaleidoscope_1.Text, { className: commonStyles.truncate, size: "s" }, b.blockName)));
        }))));
};
exports.BlocksEnteredScreenCard = BlocksEnteredScreenCard;
